import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getContatti = gql`
  ${seoFragment}
  query GetContatti($site: [String]) {
    contattiPageEntries(site: $site) {
      ... on contattiPage_Entry {
        id
        title
        seo {
          ...SeoFragment
        }
      }
    }
  }
`

export const getContactsProduct = gql`
  ${seoFragment}
  query GetContactsProduct($slug: [String], $site: [String]) {
    entry(slug: $slug, site: $site) {
      ... on vino_Entry {
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
      }
      ... on birra_Entry {
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
      }
      ... on prodottoAgricoltura_Entry {
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
      }
      ... on prodottoPanificati_Entry {
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
      }
      ... on prodottoNutraceutica_Entry {
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
      }
      typeHandle
      title
      slug
      id
    }
  }
`

export const getContactsSearched = gql`
  query GetContactsSearched($type: [String], $search: String, $site: [String]) {
    entries(type: $type, site: $site, search: $search) {
      id
      title
      slug
    }
  }
`
